<template>
	<div>
		<div class="col-lg-12 mb-8">
			<!-- Invoice History Table -->
			<student-profile-tab-finance-invoice-history-table
				:value="value"
			></student-profile-tab-finance-invoice-history-table>
		</div>
	</div>
</template>

<script>
export default {
	name: "InvoiceHistory",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}
</style>
